/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
    
        signUpsignIn365: "B2C_1A_SIGNUP_SIGNIN_A",
        // signUpsignIn365: "B2C_1A_SIGNUP_SIGNIN_DEV",
        //forgotPassword: "b2c_1_password_reset",
        // editProfile: "b2c_1_edit_profile"
    },
    authorities: {
        signUpSignIn: {
        //new auth, comes from custom policies
        authority: "https://login.mymoodbit.com/moodbitb2c.onmicrosoft.com/B2C_1A_signup_signin_A",
            // authority: "https://login.mymoodbit.com/moodbitb2c.onmicrosoft.com/B2C_1A_signup_signin_DEV",
            // authority: "https://moodbitb2c.b2clogin.com/moodbitb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_signupsigninslack&client_id=9d240eb0-0f60-4386-b180-5af0894c7ab4&nonce=defaultNonce&redirect_uri=https%3A%2F%2F37ab-68-161-217-121.ngrok.io&scope=openid&response_type=id_token&prompt=login"
        },
     
        signUpsignIn365: {
            authority: "https://login.mymoodbit.com/moodbitb2c.onmicrosoft.com/B2C_1A_signup_signin_A"
            // authority: "https://login.mymoodbit.com/moodbitb2c.onmicrosoft.com/B2C_1A_signup_signin_DEV"
        }
        // forgotPassword: {
        //     authority: "https://moodbitb2c.b2clogin.com/moodbitb2c.onmicrosoft.com/b2c_1_password_reset",
        // },
    //     editProfile: {
    //         authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_edit_profile"
    //     }
    },
     authorityDomain: "login.mymoodbit.com"
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: `${process.env.REACT_APP_B2C_CLIENT_ID}`, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Use a sign-up/sign-in user-flow as a default authority
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
         redirectUri: process.env.REACT_APP_REDIRECT_URI, // Points to window.location.origin. You must register this URI on Azure Portal/App2 Registration.
         postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "profile", "https://moodbitb2c.onmicrosoft.com/da027e06-deee-4517-b4e0-ef7ad259b78a/user_impersonation"],
   
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ["openid", "profile"],
  loginHint: "example@domain.net"
};

export const apiRequest = {
    scopes: ["https://moodbitb2c.onmicrosoft.com/da027e06-deee-4517-b4e0-ef7ad259b78a/user_impersonation"],
  }
  
  console.log(process.env.REACT_APP_REDIRECT_URI)
